import styled from 'styled-components';
import { OverlayStyleProps } from './types';

export const Overlay = styled.div<OverlayStyleProps>`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.overlay};

  ${({ $allowClickthrough }) => $allowClickthrough && `pointer-events: none;`};
`;
